// Use env var so we can use different providers to support multi env's
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const INACTIVITY_MSG =
  "You have been logged out due to inactivity.";
export const INVALID_EMAIL_ERROR_MSG =
  "The email that you have provided is not authorized to view this application.";
export const VALIDATION_CREDENTIAL_ERROR_MSG = "Something went wrong while validating your credentials. Please try to log in again."

export const API_DATA_ENTRIES_LIMIT = 512522;

export const USER_ACCOUNT_STATUS = {
  KARDIA_CARE: {
    INACTIVE: 'kardia_care_inactive',
    ACTIVE: 'kardia_care_active',
    NEEDS_PAYMENT: 'kardia_care_needs_payment',
    CONNECTED: 'kardia_care_connected',
    CONNECTED_NEEDS_PAYMENTS: 'kardia_care_connected_needs_payment'
  },
  STATUS: {
    BASIC: 'basic',
    ACTIVE: 'Active',
    CANCELED_WITH_c: 'canceled',
    CANCELED_WITH_C: 'Canceled',
    PENDING: 'Pending',
  }

}

export const ROUTES = {
  ROOT: '/',
  SHOPIFY: '/ShopifySupport',
  DEVICE_LOCK: '/DeviceLock',
  INNER_CIRCLE: '/InnerCircle'
}

export const METHOD = {
  POST: 'POST',
  GET: 'GET',
  DELETE: 'DELETE',
  PUT: "PUT"
}


// WEBPACK FOOTER //
// ./src/constants/constants.js